import { useThemeContext } from '#contexts/ThemeContext';
import { Box, Typography } from '@material-ui/core';

export const ListFeature = ({ highlights }: { highlights: string[] }) => {
  const { productHighlightsText, bulletPoints } = useThemeContext();
  return (
    <Box>
      <ul>
        {highlights.map((name, index) => (
          <li key={index}>
            <Box display='flex' alignItems='baseline' py={0.5}>
              <Box width={8} height={8} bgcolor={bulletPoints} mr={1.5} borderRadius='50%' />
              <Box width={'100%'}>
                <Typography style={{ color: productHighlightsText }} variant='subtitle2'>
                  {name}
                </Typography>
              </Box>
            </Box>
          </li>
        ))}
      </ul>
    </Box>
  );
};
